import { render } from "./DeutschePostPickupForm.vue?vue&type=template&id=5a09eab4"
import script from "./DeutschePostPickupForm.vue?vue&type=script&lang=js"
export * from "./DeutschePostPickupForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__